<template>
  <div class="menu-item">
    <div class="menu-item-wrapper">
      <div class="menu-item-content">
        <div v-if="imageExist" class="menu-item-image">
          <picture class="image-wrapper"
                   :key="`${menuItem.title}`"
                   v-lazyload="{ src: menuItem.imageSrc,
                    variant: 'menu-list' }">
            <img class="image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" :alt="menuItem.imageAlt" />
          </picture>
        </div>
        <div class="menu-item-info">
          <div class="menu-item-title">
            {{ menuItem.title }}
          </div>
          <div class="menu-item-desc">
            <div
              class="desc-wrapper"
              v-html="formattedDescription.text"
            />
            <a
              v-if="formattedDescription.isTruncated"
              href="#"
              :class="['toggle-button', 'button', showFullDescription ? 'less' : 'more']"
              @click.prevent="toggleDescriptionVisibility"
            >
              {{ showFullDescription ? tc('pageContent.seeLessButtonLabel') : tc('pageContent.seeMoreButtonLabel') }}
            </a>
          </div>
        </div>
      </div>
      <div class="schedule-list">
        <div
          v-for="item in menuItem.gridCardRows"
          :key="`key-${item.id}`"
          class="schedule-item"
        >
          <div class="schedule-item-grid">
            <div v-if="item.duration" class="duration">{{ item.duration }}</div>
            <div v-if="item.dayAndTime" class="time">
              <div v-for="(item, index) in item.dayAndTime" :key="`card-time-${index}`">{{ item }}</div>
            </div>
            <div v-if="item.price" class="price" v-html="item.price"></div>
          </div>
          <div v-if="item.priceLabel" class="price-label">{{ item.priceLabel }}</div>
        </div>
      </div>
    </div>
    <div v-if="menuItem.secondaryCTA || menuItem.primaryCTA" class="menu-item-ctas">
      <a v-if="menuItem.secondaryCTA" class="button secondary" :target="menuItem.secondaryCTATarget" :href="menuItem.secondaryCTA">{{ menuItem.secondaryCTALabel ? menuItem.secondaryCTALabel : tc('pageContent.inquireButtonLabel') }}</a>
      <a v-if="menuItem.primaryCTA" class="button--primary black size-md primary" :target="menuItem.primaryCTATarget" :href="menuItem.primaryCTA">{{ menuItem.primaryCTALabel ? menuItem.primaryCTALabel : tc('pageContent.bookButtonLabel') }}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import truncate from 'html-truncate'

export default {
  name: 'menu-card',
  props: {
    menuItem: {
      type: Object,
      required: true,
      default: () => ({})
    },
    gridColumns: {
      type: Number,
      required: true,
      default: 2
    },
  },
  data() {
    return {
      showFullDescription: false,
      emptyScene7ImageSrc: 'https://photos.mandarinoriental.com/is/image'
    }
  },

  created() {
    this.splitCardDayAndTime()
  },
  computed: {
    ...mapGetters('i18n', ['tc']),
    ...mapState('responsive', { wWidth: 'width', wHeight: 'height' }),

    formattedDescription() {
      const isTruncated = this.menuItem.description && this.menuItem.description.length > this.descMaxLength
      const text = !this.showFullDescription && isTruncated
        ? truncate(this.menuItem.description, this.descMaxLength)
        : this.menuItem.description
      return { text, isTruncated }
    },

    imageExist() {
      return this.menuItem.imageSrc && this.menuItem.imageSrc !== this.emptyScene7ImageSrc
    },

    descMaxLength() {
      if (this.wWidth < 768) {
        return 130
      }
      if (this.gridColumns === 3) {
        return this.imageExist ? 85 : 130
      }
      return this.imageExist ? 165 : 220
    }
  },
  methods: {
    toggleDescriptionVisibility() {
      this.showFullDescription = !this.showFullDescription
    },

    splitCardDayAndTime() {
      const timeRows = this.menuItem.gridCardRows

      if (timeRows && timeRows.length > 0) {
        timeRows.forEach((time) => {
          if(time?.dayAndTime?.length) {
            const result = []
            const splittedData = time?.dayAndTime?.split('|')

            splittedData.forEach((item) => {
              result.push(item.trim())
            })

            time.dayAndTime = result
          }
        })
      }
    }
  },
}
</script>
